import { NgIf } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from 'src/app/services/loading.service';

/** show (infinite) loading progress on page */
@Component({
    standalone: true,
    selector: 'riege-loading',
    imports: [MatProgressBarModule, NgIf],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
    loading = false;
    #loadingService = inject(LoadingService);

    /** listen on loading service to update state */
    constructor() {
        effect(() => (this.loading = this.#loadingService.loading()));
    }
}
